import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import AnthologyReaderForm from '../forms/anthology-reader-form';
import { anthologyReaderValidationSchema } from '../schema/anthologyReader.js';

export default function AnthologyReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Anthology Reader Details',
        altText: 'Anthology Reader',
        defaultLabel: 'Anthology Reader',
      }}
    >
      <CommonNode
        FormComponent={AnthologyReaderForm}
        schemaResolver={anthologyReaderValidationSchema}
      />
    </NodeProvider>
  );
}
